import { Component, ElementRef, HostListener, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import {
  LicenseInfo,
  UserWorkstationMapping,
} from "src/app/core/models/licenseServer";
import { LicenseServerService } from "src/app/core/services/license-server.service";
import { NavigationService } from "src/app/core/services/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { filter, interval, Subscription } from "rxjs";
import { SyncConfigService } from "../../../../core/services/sync-config.service";
import { Entities } from "src/app/core/models/globals";
import { FormArray, FormControl, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "app-license-server-list",
  templateUrl: "./license-server-list.component.html",
  styleUrls: ["./license-server-list.component.scss"],
})
export class LicenseServerListComponent implements OnInit {
  @ViewChild('scrollableTable') scrollableTable!: ElementRef;
  calculatedOffsetHeight: number = 260; // Default value

  isDataAvailable: boolean;
  licenseInfoes: LicenseInfo[];
  licenseInfoesReplica: LicenseInfo[];
  filterText: string = "";
  filterLicenses: LicenseInfo[];
  activeLicenseServerName: string;
  config = {
    itemsPerPage: 15,
    currentPage: 1,
  };
  filters = {
    users: [],
    userSelected: "all",
    workstations: [],
    workstationSelected: "all",
    totalSort: false,
    inUseSort: false,
    searchText: "",
  };
  dataReloadSubscription: Subscription;
  licenseForm: UntypedFormGroup;
  constructor(
    private _licenseServerService: LicenseServerService,
    private spinner: NgxSpinnerService,
    private _navService: NavigationService,
    private _route: ActivatedRoute,
    public syncConfig: SyncConfigService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.spinner.show("licenseInfoList");
    this._navService.breadcrumbDeployment.subscribe(
      (x) =>
        (this.activeLicenseServerName =
          x ||
          this._route.snapshot.params["licenseName"] ||
          this._route.parent.snapshot.params["licenseName"])
        );
        this._navService.sendParentData(Entities.LicenseServer);
        this._navService.sendLeftPanelIndex(0);
        this.getLicenseInfoes();
        this.startDataReloadSub();
  }

  ngAfterViewInit(): void {
    this.calculateOffsetHeight();
  }

  @HostListener("window:resize", ["$event"])
  onResize() {
    this.calculateOffsetHeight(); // Recalculate on window resize
  }

  calculateOffsetHeight() {
    if (this.scrollableTable) {
      this.calculatedOffsetHeight = window.innerHeight - this.scrollableTable.nativeElement.offsetHeight + 50;
    }
  }

  ngOnDestroy() {
    this.dataReloadSubscription?.unsubscribe();
  }

  getLicenseInfoes() {
    this.licenseForm = new UntypedFormGroup({});
    this._licenseServerService
      .getLicenseInfoForServer(this.activeLicenseServerName)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide("licenseInfoList");
          if (data == null || data?.length == 0) {
            this.isDataAvailable = false;
            return;
          }
          this.licenseInfoes = JSON.parse(JSON.stringify(data));
          this.filterLicenses = JSON.parse(JSON.stringify(data));
          this.licenseInfoes.forEach((lic) => {
            this.licenseForm.addControl(
              `${lic.licenseName}_user`,
              new FormControl()
            );
            this.licenseForm.addControl(
              `${lic.licenseName}_ws`,
              new FormControl()
            );
            if (lic.userId) this.filters.users.push(lic.userId);
            if (lic.stationName)
              this.filters.workstations.push(lic.stationName);
          });
          this.filters.users = [
            ...new Set(
              this.filters.users
                .flatMap((x) => x.split(","))
                .map((x) => x.trim())
            ),
          ];
          this.filterLicenses = [...this.licenseInfoes];
          this.filters.workstations = [
            ...new Set(
              this.filters.workstations
                .flatMap((x) => x.split(","))
                .map((x) => x.trim())
            ),
          ];
          if (this.filterText != "") {
            this.onSearch();
          }
          this.isDataAvailable = true;
        },
        error: (err) => {
          this.isDataAvailable = false;
          this.spinner.hide("licenseInfoList");
        },
      });
  }

  filteredLicenses() {
    let toSearch = this.filters.searchText.toLocaleLowerCase();
    let userSelected =
      this.filters.userSelected != "all" ? this.filters.userSelected : null;
    let workstationSelected =
      this.filters.workstationSelected != "all"
        ? this.filters.workstationSelected
        : null;
    //let licenses = this.licenseInfoes
    this.filterLicenses = this.licenseInfoes.filter(
      (lic) =>
        lic.licenseName.toLocaleLowerCase().includes(toSearch) ||
        lic.userId.toLocaleLowerCase().includes(toSearch) ||
        lic.stationName.toLocaleLowerCase().includes(toSearch)
    );
    if (userSelected) {
      this.filterLicenses = this.filterLicenses.filter((lic) =>
        lic.userId.includes(userSelected)
      );
    }
    if (workstationSelected) {
      this.filterLicenses = this.filterLicenses.filter((lic) =>
        lic.stationName.includes(workstationSelected)
      );
    }
    if (this.filterLicenses) {
      this.licenseInfoes.sort(
        (a, b) => Number(b.inUseLicenses) - Number(a.inUseLicenses)
      );
    }
    return this.filterLicenses;
  }

  resetFilter() {
    this.filters = {
      users: this.filters.users,
      userSelected: "all",
      workstations: this.filters.workstations,
      workstationSelected: "all",
      totalSort: false,
      inUseSort: false,
      searchText: "",
    };
    this.filterText = "";
    if (this.licenseInfoes) {
      // this.licenseInfoes.sort((a, b) => Number(a.totalLicenses) - Number(b.totalLicenses));
      this.licenseInfoes.sort(
        (a, b) => Number(b.inUseLicenses) - Number(a.inUseLicenses)
      );
    }
    this.filterLicenses = this.licenseInfoes;
    this.resetLicenseForm();

    this.startDataReloadSub();
  }

  sortTotal() {
    this.filters.inUseSort = false;
    this.filters.totalSort = !this.filters.totalSort;
    if (this.filters.totalSort) {
      this.filterLicenses.sort(
        (a, b) => Number(b.totalLicenses) - Number(a.totalLicenses)
      );
    } else {
      this.filterLicenses.sort(
        (a, b) => Number(a.totalLicenses) - Number(b.totalLicenses)
      );
    }
  }

  sortInUse() {
    this.filters.totalSort = false;
    this.filters.inUseSort = !this.filters.inUseSort;
    if (this.filters.inUseSort) {
      this.filterLicenses.sort(
        (a, b) => Number(b.inUseLicenses) - Number(a.inUseLicenses)
      );
    } else {
      this.filterLicenses.sort(
        (a, b) => Number(a.inUseLicenses) - Number(b.inUseLicenses)
      );
    }
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.license.listReqInterval
    ).subscribe(async () => {
      await this.getLicenseInfoes();
    });
  }

  onSearch() {
    this.filterLicenses = this.licenseInfoes;
    if (this.filterText != "") {
      this.filterLicenses = this.filterLicenses.filter((nd) => {
        if (
          nd.licenseName
            .toLowerCase()
            .includes(this.filterText.toLowerCase()) ||
          nd.stationName
            .toLowerCase()
            .includes(this.filterText.toLowerCase()) ||
          nd.userId.toLowerCase().includes(this.filterText.toLowerCase())
        ) {
          return nd;
        }
      });
    }
    this.config.currentPage = 1;
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  applyFilter() {
    this.filterLicenses = this.licenseInfoes;
    // first check the filter by workstation
    // and then filter by users
    if (this.filters.workstationSelected != "all") {
      this.filterLicenses = this.filterLicenses.filter((nd) =>
        nd.stationName
          .toLowerCase()
          .includes(this.filters.workstationSelected.toLowerCase())
      );
    }
    if (this.filters.userSelected != "all") {
      this.filterLicenses = this.filterLicenses.filter((nd) =>
        nd.userId
          .toLowerCase()
          .includes(this.filters.userSelected.toLowerCase())
      );
    }
  }

  getControlValue(licenseName) {
    return this.licenseForm.get(licenseName).value;
  }

  onItemSelect(item: string[], license: LicenseInfo, source: string) {
    this.dataReloadSubscription?.unsubscribe();
    const mappings: UserWorkstationMapping[] = license.userId
      .split(",")
      .map((entry) => {
        entry = entry.trim()
        const [user, ws, count] = entry.split(":");
        return {
          user,
          workstation: ws,
          count: parseInt(count || "0", 10),
        };
      });

    const formControlName = `${license.licenseName}_${source}`;
    let selectedValues = this.licenseForm.controls[formControlName].value;
    // if (selectedValues == null || selectedValues.length == 0) {
    //   this.licenseForm.controls[formControlName].setValue(item);
    //   selectedValues = item;
    // }
    if (source === "ws") {
      this.licenseForm.controls[`${license.licenseName}_user`].setValue([]);
      const matchingUsers = [
        ...new Set(
          mappings
            .filter((mapping) => selectedValues.includes(mapping.workstation))
            .map((mapping) => mapping.user)
            .filter(Boolean)
        ),
      ];

      this.licenseForm.controls[`${license.licenseName}_user`].setValue(
        matchingUsers
      );
    }

    if (source === "user") {
      this.licenseForm.controls[`${license.licenseName}_ws`].setValue([]);
      const matchingWorkstations = [
        ...new Set(
          mappings
            .filter((mapping) => selectedValues.includes(mapping.user))
            .map((mapping) => mapping.workstation)
            .filter(Boolean)
        ),
      ];

      this.licenseForm.controls[`${license.licenseName}_ws`].setValue(
        matchingWorkstations
      );
    }
  }

  onSelectAll(item: string[], license: LicenseInfo, source: "ws" | "user") {
    if (source == "user") {
      this.licenseForm.controls[`${license.licenseName}_ws`].setValue(
        license.licenseOnWorkstation
      );
    }
    if (source == "ws") {
      this.licenseForm.controls[`${license.licenseName}_user`].setValue(
        license.userUsingLicense
      );
    }
  }

  onDeSelectAll(item: string[], license: LicenseInfo, source: "ws" | "user") {
    if (source == "user") {
      this.licenseForm.controls[`${license.licenseName}_ws`].setValue([]);
    }
    if (source == "ws") {
      this.licenseForm.controls[`${license.licenseName}_user`].setValue([]);
    }
  }

  getControlName(license: LicenseInfo, source): string {
    return `${license.licenseName}_${source}`;
  }

  trackLicense(license: LicenseInfo) {
    const updatedLicense = this.filterLicenses.find(
      (j) => j.licenseName === license.licenseName
    );
    return license.inUseLicenses !== updatedLicense.inUseLicenses;
  }

  resetLicenseForm() {
    Object.keys(this.licenseForm.controls).forEach((controlName) => {
      this.licenseForm.get(controlName)?.reset();
    });
  }

  pageChanged(event: number) {
    this.config.currentPage = event;
  }

}
